import {
  AloftDate,
  MLSID,
  MarketTrendsType,
  isDefined,
  isUndefined,
  syntaxFNMA,
} from '@aloft/toolkit-shared';

import { Tkv2MarketConditionsState } from '../types.ts';
import { createCompTransactionsFromTkv2 } from '../zillow/createCompTransactionsFromTkv2.ts';
import { getHousingTrendsData } from '../zillow/getHousingTrendsData.ts';
import { AnalysisPeriodMonths, ZillowHomeValueIndexTrendsData } from '../zillow/types.ts';
import { getHousingTrendsInterval } from './getHousingTrendsInterval.ts';

export const getFilteredHousingTrendsData = (
  isZillow: boolean,
  trendsData: MarketTrendsType | undefined,
  effectiveDate: AloftDate,
  comps: Tkv2MarketConditionsState['comps'],
  compSequence: Tkv2MarketConditionsState['compSequence'],
  _analysisPeriodMonths?: AnalysisPeriodMonths,
): ZillowHomeValueIndexTrendsData | undefined => {
  const housingTrendsData = trendsData
    ? getHousingTrendsData(
        isZillow,
        effectiveDate,
        trendsData,
        createCompTransactionsFromTkv2(comps, compSequence),
        compSequence,
      )
    : undefined;

  const analysisPeriodMonths = isUndefined(_analysisPeriodMonths)
    ? getHousingTrendsInterval(housingTrendsData)
    : _analysisPeriodMonths;

  // Filter housingTrendsData to the analysis period range [effectiveDate - analysisPeriodMonths, effectiveDate]
  const startOfPeriod = effectiveDate.subtractMonths(analysisPeriodMonths);
  const startOfPeriodIsoMonth = syntaxFNMA.aloftDateToIsoMonth(startOfPeriod);
  const startIndex = housingTrendsData?.historical.findIndex(
    (val) => val.month === startOfPeriodIsoMonth,
  );

  const sourcesAsSet: Set<MLSID> = new Set();
  trendsData?.monthly_trends.historical_data.forEach((x) =>
    x.sourceMLSes?.forEach((y) => sourcesAsSet.add(y)),
  );
  const sources: MLSID[] | undefined =
    sourcesAsSet.size > 0 ? [...sourcesAsSet.values()] : undefined;

  return housingTrendsData
    ? {
        isZillow,
        historical:
          isDefined(startIndex) && startIndex >= 0
            ? housingTrendsData?.historical.slice(startIndex + 1)
            : [],
        projection: housingTrendsData?.projection ?? [],
        effectiveDate,
        sources,
      }
    : undefined;
};
